import React, {FunctionComponent, useState} from 'react';

import styled from 'styled-components';

import {useMediaQueryContext} from '../../../../providers/MediaQueryProvider';

type Background = {
  height: number;
  isLoaded: boolean;
  src: string;
  thumb: string;
};

const Background = styled.div<Background>`
  background-image: url(${({isLoaded, src, thumb}) => (isLoaded ? src : thumb)});
  background-size: cover;
  background-position: 50% 50%;
  height: ${({height}) => `${height - 80 - 96}px`};
  margin-bottom: 8px;
  padding: 8px 0 72px;
  width: 100%;

  @media screen and (max-width: 700px) {
    height: ${({height}) => `${height - 48}px`};
    padding: 8px 0 40px;
  }
`;

type QuickloadImage = {
  alt: string;
  thumb: string;
  src: string;
};

const QuickloadImage: FunctionComponent<QuickloadImage> = ({alt, children, thumb, src}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const size = useMediaQueryContext();

  return (
    <Background isLoaded={isLoaded} src={src} thumb={thumb} height={size.height}>
      {children}
      <img onLoad={() => setIsLoaded(true)} style={{display: 'none'}} alt={alt} src={src} />
    </Background>
  );
};

export default QuickloadImage;
